import React, { Component } from 'react'

export default class Finance extends Component {

  render() {
    return (
        <div>
          <div className="insid-header activity-header" style={{marginTop: '100px'}}>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="insid-header-text activity-header-text">
                    <h1 className="wow fadeIn" data-wow-duration=".2s" data-wow-delay=".1s">
                      Finanza e Tesoreria
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section className="activity about2">
            <div className="container">
              <div className="row">
                <div className="col-sm-12 col-lg-12">
                  <div className="activity-text wow fadeIn animated" data-wow-duration=".5s" data-wow-delay=".2s">
                    <h2 className="activity-h2">Dettagli</h2>
                    <ul>
                      <li>Supporto nella gestione e nel monitoraggio della <b>finanza</b> a breve.</li>
                      <li>Supporto nella gestione dei rapporti con banche ed istituzioni finanziarie.</li>
                      <li>Attività di advisory in relazione ad interventi di ristrutturazione:</li>
                      <li className="list-none">
                        <ul className="list-square">
                          <li>supporto nello sviluppo di piani di <b>ristrutturazione</b> del business.</li>
                        </ul>
                      </li>
                      <li>sviluppo della documentazione di supporto sia per esigenze interne che di dialogo con il sistema bancario e finanziario:</li>
                      <li className="list-none">
                        <ul className="list-square">
                          <li>Piano economico e patrimoniale comprensivo di indicatori e commenti esplicativi.</li>
                          <li>Piano di fattibilità finanziario con sviluppo analitico dei flussi finanziari.</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )
  }
}



// WEBPACK FOOTER //
// ./src/pages/finance.it.js